module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0029.jpg?v=bdaedffa";